<ion-backdrop *ngIf="loading" style="z-index: 0" class="backdrop-opacity"></ion-backdrop>
<div class="container" *ngIf="loading">
  <div class="spinner-parent d-flex ion-justify-content-center">
    <div class="spinner-container" [ngClass]="{ 'is-web': !appFeaturesState.isIos && !appFeaturesState.isAndroid }">
      <span class="loading"> {{ message ?? 'Loading' }} </span> &nbsp;
      <ion-spinner color="secondary"></ion-spinner>
    </div>
  </div>
</div>
